export default __webpack_public_path__ + "static/logo1-fd8b6f940e47fa9223a4bd5e5342c94d.png";